const globalVars={
    isMobile:false,
    maxListingItemsPerPage:Math.floor((window.innerHeight - 320)/48),
    countries:[]
};

export default globalVars;
